import { GoogleOAuthProvider } from '@react-oauth/google';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { RecoilRoot } from 'recoil';
import App from './App';
import ErrorFallback from './components/ErrorFallback';
import { getGoogleClientId } from './config/googleClient';
import { AuthProvider } from './contexts/Auth';
import ThemeContextProvider from './contexts/ThemeContext';
import { TitleProvider } from './contexts/TitleContext';
import './index.css';
import reportWebVitals from './reportWebVitals';

const googleClientId = getGoogleClientId();
const IdentityProvider = ({ children }) => process.env.REACT_APP_SUITE_SSO === 'true'
  ? children
  : <GoogleOAuthProvider clientId={googleClientId}>{children}</GoogleOAuthProvider>;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary
    FallbackComponent={ErrorFallback}
    onReset={() => {
      localStorage.clear();
      window.location.href = '/';
    }}
    onError={(error, errorInfo) => {
      console.error('Caught an error:', error, errorInfo);
    }}
  >
    <RecoilRoot>
      <ThemeContextProvider>
        {/* ID-token Sign-In only; no extra OAuth scopes on the provider. */}
        <IdentityProvider>
          <AuthProvider>
            <SnackbarProvider>
              <TitleProvider>
                <App />
              </TitleProvider>
            </SnackbarProvider>
          </AuthProvider>
        </IdentityProvider>
      </ThemeContextProvider>
    </RecoilRoot>
  </ErrorBoundary>
);

reportWebVitals();
